import * as Sentry from '@sentry/browser';
import CONFIGURABLE_CONSTANTS from 'constants/configurable.constants';
// eslint-disable-next-line import/no-unresolved
import packageJson from 'packageJson';
import { getPTPInitData, setPTPInitData } from './sentry.utils';

interface PtpErrorOptions {
  tags?: Record<string, string>;
}

const ptpClient = new Sentry.BrowserClient({
  dsn: CONFIGURABLE_CONSTANTS.sentryDns,
  transport: Sentry.makeFetchTransport,
  stackParser: Sentry.defaultStackParser,
  allowUrls: [/parcelperform\.com/i],
  release: `${packageJson.name}@${packageJson.version}`,
  beforeSend: (event, hint) => {
    const { ppInitHostUrl } = getPTPInitData();

    // eslint-disable-next-line
    event.extra = {
      ...(event.extra || {}),
      ...{
        ppInitHostUrl,
        ppCaptureHostURL: window.location.href,
      },
    };

    // const dataDebugInit = replaceSensitiveContent(
    //   (window as any).ppInitBody,
    // ).outerHTML;
    // const dataDebugCapture = replaceSensitiveContent(document.body).outerHTML;

    // eslint-disable-next-line
    // hint.attachments = [
    //   ...(hint.attachments || []),
    //   {
    //     filename: `debugInit_${event.event_id}.txt`,
    //     contentType: 'text/plain',
    //     data: dataDebugInit,
    //   },
    //   {
    //     filename: `debugCapture_${event.event_id}.txt`,
    //     contentType: 'text/plain',
    //     data: dataDebugCapture,
    //   },
    // ];

    return event;
  },
  integrations: [
    ...Sentry.getDefaultIntegrations({}).filter((defaultIntegration) => {
      return !['BrowserApiErrors', 'Breadcrumbs', 'GlobalHandlers'].includes(
        defaultIntegration.name,
      );
    }),
    Sentry.rewriteFramesIntegration({
      prefix: '~/',
      root: CONFIGURABLE_CONSTANTS.publicURL,
    }),
  ],
});

const ptpScope = new Sentry.Scope();
ptpScope.setClient(ptpClient);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ptpCatchError = (
  error: any,
  errorInfo?: any,
  options?: PtpErrorOptions,
) => {
  if (!CONFIGURABLE_CONSTANTS.sentryDns) return;

  // Always clone to avoid leaking tags/extras into the shared scope between calls
  const scope = ptpScope.clone();

  if (options?.tags) {
    // set custom tags
    Object.entries(options.tags).forEach(([key, value]) => {
      scope.setTag(key, value);
    });
  }

  if (errorInfo) {
    scope.setExtras(errorInfo);
  }
  scope.captureException(error);
};

export { ptpClient, ptpCatchError, setPTPInitData };
export type { PtpErrorOptions };
